// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"7f297936","345":"08ed7ae6","494":"28ad3e23","570":"e1eedba6","878":"0f30f0ce","982":"08ed7ae6"}[chunkId] + ".css";
};